import type { LiteralUnion } from "type-fest";

export const partners = [
    "aafes",
    "adt",
    "amazonrouter",
    "asurion",
    "asurionhomeplus",
    "asuriontechcare",
    "att",
    "attconnectedhome",
    "bluestream",
    "brightspeed",
    "cactus",
    "cox",
    "cricket",
    "dell",
    "dish",
    "ee",
    "expertuniversity",
    "fios",
    "frontier",
    "hotwire",
    "hpsales",
    "koodo",
    "leakprotect",
    "liberty",
    "life360",
    "mcafee",
    "mcafeesecurityscan",
    "mediacom",
    "microsoft",
    "nexcom",
    "nrg",
    "optimum",
    "optimumbiz",
    "others",
    "pilot",
    "reach",
    "samsungna",
    "smartpay",
    "sparklight",
    "sparklightsales",
    "staples",
    "stapleshome",
    "staplessmb",
    "telus",
    "telushomepro",
    "thesource",
    "tmobile",
    "tracfone",
    "unknown",
    "uscellular",
    "verizon",
    "verizonconnectedhome",
    "verizonwholeoffice",
    "viasat",
    "vzwsmb",
    "xboxcareplus",
    "yahoo",
    "youtubetv",
] as const;
/** known partner or any string */
export type Partner = LiteralUnion<(typeof partners)[number], string>;

/**
 * Converts a partner value from UI display text to the canonical partner **key** expected
 * by APIs and backends: lowercase, with spaces and `&` removed (e.g. how "AT&T" is shown
 * to users vs. the `att` slug sent in requests).
 *
 * @param partner - Label or mixed-case string from the UI (e.g. `"AT&T"`)
 *   or any string to normalize toward the backend form.
 * @returns The normalized key, e.g. `"AT&T"` → `"att"`, `"Verizon"` → `"verizon"`.
 *
 * @example
 * normalizePartnerKeyForApi("AT&T"); // "att"
 */
export function normalizePartnerKeyForApi(partner: string): string {
    return partner.toLowerCase().replace(/&/g, "").replace(/ /g, "");
}
